import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { ResendVerificationFeature } from "@/features/auth/ResendVerificationFeature";

const resendSearchSchema = z.object({
  email: z.string().optional(),
});

function ResendVerificationPage() {
  const { email } = Route.useSearch();
  return <ResendVerificationFeature prefilledEmail={email} />;
}

export const Route = createFileRoute("/(auth)/resend-verification")({
  validateSearch: resendSearchSchema,
  component: ResendVerificationPage,
  staticData: { authorize: false },
});
